import type { GameEvent } from '@core/events/EventBus';

export const GameplayEvents = {
  runStarted: 'gameplay:run-started',
  roundPreview: 'gameplay:round-preview',
  roundGrid: 'gameplay:round-grid',
  roundCorrect: 'gameplay:round-correct',
  runEnded: 'gameplay:run-ended',
} as const;

export interface RunStartedEvent extends GameEvent {
  type: typeof GameplayEvents.runStarted;
}

export interface RoundPreviewEvent extends GameEvent {
  type: typeof GameplayEvents.roundPreview;
}

export interface RoundGridEvent extends GameEvent {
  type: typeof GameplayEvents.roundGrid;
}

export interface RoundCorrectEvent extends GameEvent {
  type: typeof GameplayEvents.roundCorrect;
  score: number;
}

export interface RunEndedEvent extends GameEvent {
  type: typeof GameplayEvents.runEnded;
  finalScore: number;
}
